export default class UserSettingsModel extends Backbone.Model {
  constructor(options) {
    super(options);
  }

  sync(method, model, options) {
    switch (method) {
      case 'patch':
        // tmp fix for circular JSON until I am more of a BB ninja.
        model.attributes.user_setting.settings = null;
        return Backbone.sync(method, model, options);
    }
  }
}
